<template>
  <div
    ref="messages"
    class="flex h-full w-full overflow-x-none overflow-y-auto fancy-scrollbar p-2"
  >
    <div v-if="loading" class="mx-auto self-center text-center">
      <Loader />
    </div>
    <ul v-else-if="resolved" class="w-full divide-y mt-auto">
      <li v-for="(message, idx) in messages" :key="idx" class="px-4 py-3">
        <ConversationMessageItem :message="message" />
      </li>
    </ul>
    <div v-else class="self-center justify-self-center">
      Something went wrong! Could not load messages.
    </div>
  </div>
</template>

<script>
import { orderBy } from 'lodash-es';
import ConversationMessageItem from './ConversationMessageItem.vue';

export default {
  components: { ConversationMessageItem },
  props: {
    conversationId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      resolved: false,
      rejected: false,
    };
  },
  computed: {
    messages() {
      return orderBy(
        this.$store.getters['ui/conversationMessages/itemsByParent'](this.conversationId),
        ['id'],
        ['asc']
      );
    },
  },
  created() {
    this.listenConversationMessages();
    this.fetchConversationMessages();
  },
  destroyed() {
    this.leaveConversation();
    this.clearMessages();
  },
  methods: {
    listenConversationMessages() {
      window.Echo.private(`conversations.${this.conversationId}`).listen(
        '.conversation_message.created',
        (e) => {
          this.$store.dispatch('ui/conversationMessages/persistMessage', {
            conversationId: this.conversationId,
            message: e.message,
          });

          this.$nextTick(() => {
            this.scrollToBottom();
          });
        }
      );
    },
    async fetchConversationMessages() {
      try {
        this.loading = true;
        await this.$store.dispatch('ui/conversationMessages/load', {
          conversationId: this.conversationId,
        });

        this.resolved = true;

        this.$nextTick(() => {
          this.scrollToBottom();
        });
      } catch (error) {
        this.rejected = true;
      } finally {
        this.loading = false;
      }
    },
    scrollToBottom() {
      const messagesEl = this.$refs.messages;
      // eslint-disable-next-line no-param-reassign
      setTimeout(() => {
        messagesEl.scrollTop = messagesEl.scrollHeight;
      }, 0);
    },
    leaveConversation() {
      window.Echo.leave(`conversations.${this.conversationId}`);
    },
    clearMessages() {
      this.$store.dispatch('ui/conversationMessages/clearByParent', {
        parentId: this.conversationId,
      });
    },
  },
};
</script>
